import React from 'react';
import { Col, Row } from 'reactstrap';
import language from '../../../../assets/languages/language';
import { showFailure } from '../../../../common/toast';
import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import App_data from '../../../config/App_data';
import ReverseTimer from '../ReverseTimer';
import { renderHTMLContent } from '../../../../common/function';

function ViewQuestions(props) {
  const {
    id,
    question = '',
    question_number,
    is_multiple,
    development_justification = '',
    is_development,
    timing,
    getPreviousQuestion,
    getNextQuestion,
    setJustification,
    setUserChoice,
    justification1,
    selectedIndex,
    displayError,
    stopTimer,
    disableNavigationButtons,
    caseQuestions,
    questionIndex,
    attemptedQuestions,
    errorMessageOnValidate,
    multiple_answer,
    selectedChoice,
    showResult,
    _getResult,
    _saveQuestion,
    _displayReportForm,
    // save_text,
    bookmarkCSS,
    bookmarkColor,
    questionData,
  } = props;
  const choices = [];
  for (const objKey in props)
    if (objKey.includes('choice')) if (props[objKey]) choices.push(props[objKey]);
  return (
    <div className='note-section note-section-new'>
      <div className='card view_questionhtml'>
        {question ? (
          <div className='font-lusitana'>
            <div className='card-header'>
              <img
                src={`${App_data.frontend_url}/img/question_bank/question_icon_blue.svg`}
                className='margin_right_20'
                width='30'
                alt=''
              />
              Question {question_number} -{' '}
              {/* {console.log('disableNavigationButtons', !disableNavigationButtons)} */}
              <div className='float-right text-right'>
                <i
                  // disabled={
                  //   caseQuestions?.length === parseInt(questionIndex) -1 ? true:false
                  // }
                  className={`fa fa-angle-left ${parseInt(questionIndex, 10) !== 0 ? 'ques_arrow' : 'ques_arrow_disable'
                    } pointer_class`}
                  onClick={
                    () =>
                      // !disableNavigationButtons
                      // ?
                      getPreviousQuestion()
                    // : showFailure(
                    // 'Please select grading before proceeding to previous question'
                    // )
                  }
                />
                <i
                  className={`fa fa-angle-right ${!attemptedQuestions.length || attemptedQuestions.length !== caseQuestions.length
                    ? caseQuestions.length !== parseInt(questionIndex, 10) + 1
                      ? 'ques_arrow'
                      : 'ques_arrow_disable'
                    : caseQuestions.length + 1 === attemptedQuestions.length + 1
                      ? 'ques_arrow'
                      : 'ques_arrow_disable'
                    } pointer_class `}
                  onClick={() =>
                    !disableNavigationButtons
                      ? getNextQuestion()
                      : showFailure('Please select grading before proceeding to next question')
                  }
                // disabled={disableNavigationButtons}
                />
              </div>
            </div>
            <div className='card-block'>
              <Row>
                <Col xs='12' sm='12' lg='9'>
                {renderHTMLContent(question, "div", "text-justify view_questionhtml margin_bottom_20")}
                  <Row>
                    {development_justification.includes('&;') ? (
                      <Col className={`border-gray rounded p-1`} md='12' xs='12' sm='12'>
                        <b>{development_justification.split('&;')[0].split(':')[0]} :</b>
                        <input
                          type='text'
                          className='border-0 w-50 view_questionhtml'
                          placeholder='Please write your answer'
                        />
                      </Col>
                    ) : null}
                    {choices.length || development_justification.includes('&;') ? (
                      <Col xs='12' md={development_justification.includes('&;') ? '12' : '3'}>
                        <div
                          className={`${development_justification.includes('&;')
                            ? 'justify-content-around'
                            : 'flex-column'
                            }  d-flex border ${is_multiple
                              ? 'border-gray rounded mb-sm-1 mb-md-0 question_sidebar'
                              : ''
                            } `}
                        >
                          {choices.map((choice, index) => (
                            <div
                              key={index}
                              className={`d-flex align-items-center pointer_class sidebar_item ${is_multiple ? 'border-0' : 'border-gray rounded'
                                } ${selectedIndex === index ? 'clicked_box' : ''} ${showResult &&
                                  selectedChoice === choice &&
                                  selectedChoice !== multiple_answer
                                  ? 'failure text-white'
                                  : ''
                                } ${showResult && choice === multiple_answer ? 'success text-white' : ''
                                }`}
                              name='selectedChoice'
                              onClick={() => !showResult && setUserChoice(choice, index)}
                            >
                              <span>{choice}</span>
                            </div>
                          ))}
                        </div>
                      </Col>
                    ) : null}
                    <Col
                      xs='12'
                      md={
                        development_justification.includes('&;') ||
                          (is_development && !choices.length)
                          ? '12'
                          : '9 pl-md-0'
                      }
                      className={`${development_justification.includes('&;') ||
                        (is_development && !choices.length)
                        ? ''
                        : ''
                        } `}
                    >
                      {is_development ? (
                        is_multiple ? (
                          <textarea
                            className='w-100 h-100 view_questionhtml'
                            placeholder='Write your justification here'
                            onChange={event => {
                              setJustification(event);
                            }}
                            value={justification1}
                            name='justification1'
                          />
                        ) : choices.length ? (
                          choices.map((choice, index) => (
                            <div className='h-100p'>
                              <textarea
                                placeholder='Write your justification here'
                                className='w-100 h-100 min-height-150 view_questionhtml'
                                onChange={event => {
                                  setJustification(event);
                                }}
                                value={props[`justification${index + 1}`]}
                                name={[`justification${index + 1}`]}
                              />
                            </div>
                          ))
                        ) : (
                          <textarea
                            className='w-100 h-100 min-height-150 view_questionhtml'
                            placeholder='Write your justification here'
                            onChange={event => {
                              setJustification(event);
                            }}
                            value={justification1}
                            name='justification1'
                          />
                        )
                      ) : null}
                    </Col>
                  </Row>
                  {displayError ? (
                    <h6 className='text-danger mt-1 mb-0'>{errorMessageOnValidate}</h6>
                  ) : null}

                  {questionData && questionData.question && (
                    <Row>
                      <Col md='12' sm='12'>
                        <div className='row note-section-new align-items-center mt-2'>
                          <ValidateSaveReportIcon
                            all_questions={questionIndex}
                            isQue={true}
                            _getResult={_getResult}
                            _saveQuestion={_saveQuestion}
                            _displayReportForm={_displayReportForm}
                            save_text={language.LC().SAVE_QUESTION}
                            bookmarkCSS={bookmarkCSS}
                            bookmarkColor={bookmarkColor}
                            className='p-0'
                            showResult={showResult}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
                <Col
                  lg='3'
                  sm='12'
                  xs='12'
                  className='d-flex flex-column justify-content-around mt-2'
                >
                  <ReverseTimer seconds={timing} key={id} stopTimer={stopTimer} />
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <h4 className='text-center p-2'>No Question found</h4>
        )}
      </div>
    </div>
  );
}

export default ViewQuestions;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/Layout/ViewQuestions.jsx